<template>
    <div>
        <div v-loading="tableLoading">
            <el-empty v-if="totalItems==0" description="暂无数据" style="height:255px;"></el-empty>
            <el-table v-else :data="dynamicList" :header-cell-style="{'background-color':'#F2F2F2','color':'#3A3A3A'}">
                <el-table-column prop="contactPerson" label="联系人" width="150px"></el-table-column>
                <el-table-column prop="followContent" label="内容" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-html="scope.row.followContent"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="followTime" label="时间" width="150px"></el-table-column>
                <el-table-column prop="follower" label="跟进人" width="150px">
                    <template slot-scope="scope">
                        <el-popover trigger="hover">
                            <ColleageCard v-if="scope.row.card2Show" :ckey="scope.row.followerKey" />
                            <div slot="reference" @mouseenter="hoverCard(scope.row,2)">{{scope.row.follower}}</div>
                        </el-popover>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="nextFollowTime" label="下次跟进时间" width="150px"></el-table-column> -->
                <el-table-column label="附件" width="80px">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" v-if="scope.row.annex.length > 0" @click="viewAnnex(scope.row.annex)">查看</el-button>
                        <span v-else>暂无附件</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination hide-on-single-page background layout="total,sizes,prev,pager,next" :page-sizes="[10, 20, 40]" :page-size.sync="pageSize" @size-change="pageSizeChange" :total="totalItems" style="float:right;margin:8px 16px;" :current-page.sync="pageIndex" @current-change="pageIndexChange"></el-pagination>
        </div>

        <el-dialog title="附件" :visible.sync="annexVisible" width="500px">
            <div style="display: flex;gap: 10px;">
                <div v-for="(row,index) in annexList" :key="index">
                    <div v-if="isImageFile(row.name)">
                        <el-image style="width: 75px; height: 75px" :src="row.url" :preview-src-list="[row.url]" />
                    </div>
                    <el-link v-else :href="row.url" :underline="false" target="_blank">
                        <div class="annexItem">
                            <i class="el-icon-document"></i>
                            <div>
                                <p class="p_name">{{row.name}}</p>
                                <p class="p_size">{{row.size}}</p>
                            </div>
                        </div>
                    </el-link>
                </div>
            </div>
            <div slot="footer">
                <el-button @click="annexVisible = false" size="small">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ColleageCard from "@/components/ColleageCard.vue"; //同事卡片
export default {
    components: { ColleageCard },
    data() {
        return {
            customerKey: "",
            tableLoading: false,
            dynamicList: [],
            totalItems: 0,
            pageIndex: 1,
            pageSize: 10,
            //附件
            annexVisible: false,
            annexList: [],
        };
    },
    methods: {
        hoverCard(row,type){
            if(type == 1){ row.card1Show = true;}
            if(type == 2){ row.card2Show = true;}
            if(type == 3){ row.card3Show = true;}
        },

        getDealingsMail(){
            if(!this.customerKey) return;
            this.tableLoading = true;
            this.$axios.post(`${this.$customerUrl}/Company/DealingsMail`,{
                customerKey: this.customerKey,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
            }).then((res) => {
                const { isSuccess , data } = res;
                this.tableLoading = false;
                if (isSuccess) {
                    this.dynamicList = data.datas.map(item=>({
                        ...item,
                        card1Show: false,
                        card2Show: false,
                        card3Show: false,
                    }))
                    this.totalItems = data.totalItems;
                }
            });
        },
        pageIndexChange(page) {
            this.pageIndex = page;
            this.getDealingsMail();
        },
        pageSizeChange() {
            this.pageIndex = 1;
            this.getDealingsMail();
        },

        isImageFile(fileName) {
            return ["png", "jpg", "jpeg"].includes(fileName.substring(fileName.lastIndexOf(".") + 1));
        },
        //查看附件内容
        viewAnnex(annex){
            this.annexVisible = true;
            this.annexList = annex;
        },

    },
    mounted() {
        this.customerKey = this.$route.query.customerKey || "";
        this.getDealingsMail(); //获取邮件往来
    },
};
</script>

<style lang="scss" scoped>
.annexItem{
    display: flex;
    align-items: center;
    background: #f8f8f8;
    padding: 10px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    font-size: 14px;
    .el-icon-document{
        font-size: 30px;
        margin-right: 8px;
    }
    .p_name{
        color: #3A3A3A;
        width: 120px;
        line-height: 24px;
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .p_size{
        color: #909090;
        line-height: 24px;
    }
}
</style>